module.exports = __webpack_public_path__ + "static/media/dropdown-arrow.0ba4ab6d.svg";